import React from 'react';
import { ArrowUpRight } from './components/ArrowUpRight/ArrowUpRight';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import { PersonalProjects } from './components/PersonalProjects/PersonalProjects';
import { ExperienceTimeline } from './components/ExperienceTimeline/ExperienceTimeline';

function App() {
  return (
    <div className="portfolio">
      <a className="skip-link" href="#main">Skip to content</a>
      <header className="portfolio-header">
        <a className="wordmark" href="#main" aria-label="Kyle Herrmann, home">kh<span>.</span>
        </a>

      </header>

      <main id="main">
        <section className="portfolio-hero" aria-labelledby="hero-title">
          <div className="hero-copy">
            <p className="eyebrow">
              <span className="location-dot" /> Vancouver, BC <span className="eyebrow-divider">/</span> Software Engineer II</p>
            <h1 id="hero-title">Kyle<br />Herrmann<span className="name-period">.</span>
            </h1>
            <p className="hero-statement">Full-stack engineer.<br />
              <span>Web & mobile applications.</span>
            </p>
            <p className="hero-description">I build data visualizations and reporting systems that make complex information easier to use. I work across React, GraphQL, and Rails, with a focus on performance and scalability.</p>
            <div className="hero-actions">
              <a className="primary-link" href="#experience">View experience <span aria-hidden="true">↓</span>
              </a>
              <a className="secondary-link" href={`${process.env.PUBLIC_URL}/Kyle-Herrmann-CV.pdf`} download="Kyle-Herrmann-CV.pdf">Download CV <span aria-hidden="true">↓</span></a>
              <a className="secondary-link" href="https://www.linkedin.com/in/kyle-m-h/" target="_blank" rel="noreferrer">LinkedIn <span aria-hidden="true"><ArrowUpRight /></span>
              </a>
            </div>
          </div>
          <aside className="engineering-note" aria-label="Engineering focus">
            <div className="note-heading">
              <span>What I work with</span>
              <span aria-hidden="true"><ArrowUpRight /></span>
            </div>
            <div className="system-flow">
              <div>
                <span className="flow-index">01</span>
                <strong>Backend</strong>
                <small>Rails · SQL · GraphQL</small>
              </div>
              <span className="flow-connector" aria-hidden="true" />
              <div>
                <span className="flow-index">02</span>
                <strong>Frontend</strong>
                <small>React · TypeScript · React Native</small>
              </div>
              <span className="flow-connector" aria-hidden="true" />
              <div>
                <span className="flow-index">03</span>
                <strong>Current focus</strong>
                <small>Time tracking · Field worker experience</small>
              </div>
            </div>
            <p>Workforce Management at Jobber.</p>
            <div className="note-footer">
              <span>Currently at</span>
              <strong>Jobber</strong>
            </div>
          </aside>
          <div className="hero-baseline">
            <span>Web, mobile & reporting systems</span>
            <a href="#experience">Experience <span aria-hidden="true">↓</span>
            </a>
          </div>
        </section>

        <ExperienceTimeline />
        <PersonalProjects />
        <section className="contact-section" aria-labelledby="contact-title">
          <p className="eyebrow">Have something in mind?</p>
          <h2 id="contact-title">Get in touch.</h2>
          <a href="mailto:contact@kyle-herrmann.ca">contact@kyle-herrmann.ca <span aria-hidden="true"><ArrowUpRight /></span>
          </a>
        </section>
      </main>
      <footer className="portfolio-footer">
        <span>Kyle Herrmann · Vancouver, BC</span>
        <span>Built with React & TypeScript</span>
      </footer>
    </div>
  );
}

export default App;
